// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__B4jZZ","container":"Modal_container__hwRwo","closeButton":"Modal_closeButton__dO-uI"};